import React from 'react';
import { Link } from 'react-router-dom';

const Section = ({ title, children }) => (
  <div style={{ marginBottom: '32px' }}>
    <h2 style={{ fontSize: '18px', fontWeight: '700', color: 'var(--text-primary)', marginBottom: '12px', borderLeft: '4px solid var(--primary-color)', paddingLeft: '12px' }}>
      {title}
    </h2>
    <div style={{ color: 'var(--text-secondary)', fontSize: '15px', lineHeight: '1.8' }}>
      {children}
    </div>
  </div>
);

const PoliticaPrivacidade = () => {
  const dataAtualizacao = '14 de abril de 2025';

  return (
    <div className="container" style={{ padding: 'var(--spacing-xl) var(--spacing-md)', maxWidth: '860px', margin: '0 auto' }}>
      {/* Breadcrumb */}
      <div style={{ marginBottom: '24px' }}>
        <Link to="/" style={{ color: 'var(--text-secondary)', fontSize: '14px', display: 'inline-flex', alignItems: 'center', gap: '6px', textDecoration: 'none' }}>
          <i className="fas fa-arrow-left"></i> Voltar para a Home
        </Link>
      </div>

      <div style={{ backgroundColor: 'var(--white)', borderRadius: 'var(--radius-md)', boxShadow: 'var(--shadow-sm)', padding: '40px' }}>
        {/* Cabeçalho */}
        <div style={{ marginBottom: '40px', paddingBottom: '24px', borderBottom: '1px solid var(--border-color)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
            <i className="fas fa-shield-alt" style={{ fontSize: '28px', color: 'var(--primary-color)' }}></i>
            <h1 style={{ fontSize: '28px', fontWeight: '800', color: 'var(--text-primary)', margin: 0 }}>
              Política de Privacidade
            </h1>
          </div>
          <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>
            Última atualização: <strong>{dataAtualizacao}</strong> &nbsp;|&nbsp; Versão 1.0
          </p>
          <div style={{ marginTop: '16px', padding: '16px', backgroundColor: 'rgba(52, 131, 250, 0.06)', borderRadius: '8px', border: '1px solid rgba(52, 131, 250, 0.15)', fontSize: '14px', color: '#1a56c4', lineHeight: '1.6' }}>
            <i className="fas fa-info-circle" style={{ marginRight: '8px' }}></i>
            Esta Política descreve como o <strong>Ofertiz</strong> coleta, usa, armazena e protege seus dados pessoais, em conformidade com a <strong>Lei Geral de Proteção de Dados (LGPD — Lei nº 13.709/2018)</strong>.
          </div>
        </div>

        <Section title="1. Quem Somos">
          <p>O <strong>Ofertiz</strong> é uma plataforma digital de curadoria de ofertas e descontos, acessível em <strong>ofertiz.com.br</strong>. O responsável pelo tratamento dos seus dados pessoais é o operador do site Ofertiz.</p>
          <p style={{ marginTop: '8px' }}>
            <strong>Canal de privacidade (DPO):</strong> Para exercer seus direitos, entre em contato pelo e-mail{' '}
            <a href="mailto:contato@ofertiz.com.br" style={{ color: 'var(--primary-color)' }}>contato@ofertiz.com.br</a> com o assunto <em>"LGPD — Direitos do Titular"</em>.
          </p>
        </Section>

        <Section title="2. Dados Pessoais que Coletamos">
          <p>Coletamos os seguintes dados, a depender de como você usa o Ofertiz:</p>
          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '12px', fontSize: '14px' }}>
            <thead>
              <tr style={{ backgroundColor: '#f8f9fa' }}>
                <th style={{ border: '1px solid #dee2e6', padding: '10px', textAlign: 'left' }}>Dado</th>
                <th style={{ border: '1px solid #dee2e6', padding: '10px', textAlign: 'left' }}>Finalidade</th>
                <th style={{ border: '1px solid #dee2e6', padding: '10px', textAlign: 'left' }}>Base Legal (LGPD)</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['Nome e e-mail', 'Identificação e autenticação', 'Consentimento (Art. 7, I)'],
                ['Foto de perfil', 'Personalização da interface', 'Consentimento (Art. 7, I)'],
                ['Senha (hash)', 'Autenticação com e-mail', 'Consentimento (Art. 7, I)'],
                ['Endereço e CPF', 'Envio de prêmios e cashback (opcional)', 'Consentimento (Art. 7, I)'],
                ['Chave PIX', 'Pagamento de cashback (opcional)', 'Consentimento (Art. 7, I)'],
                ['Curtidas e favoritos', 'Personalização e histórico', 'Consentimento (Art. 7, I)'],
                ['Comentários', 'Interação na plataforma', 'Consentimento (Art. 7, I)'],
                ['Histórico de pontos', 'Programa de recompensas', 'Consentimento (Art. 7, I)'],
                ['Cliques em ofertas', 'Estatísticas e recompensas', 'Legítimo interesse (Art. 7, IX)'],
              ].map(([dado, finalidade, base], i) => (
                <tr key={i} style={{ backgroundColor: i % 2 === 0 ? 'white' : '#fafafa' }}>
                  <td style={{ border: '1px solid #dee2e6', padding: '10px', fontWeight: '600' }}>{dado}</td>
                  <td style={{ border: '1px solid #dee2e6', padding: '10px' }}>{finalidade}</td>
                  <td style={{ border: '1px solid #dee2e6', padding: '10px', fontSize: '13px' }}>{base}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Section>

        <Section title="3. Uso de Cookies">
          <p>Utilizamos <strong>cookies essenciais</strong> para o funcionamento do site (autenticação, preferências) e cookies de análise para entender como você usa a plataforma.</p>
          <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '6px' }}><strong>Cookies essenciais:</strong> necessários para login e funcionamento básico. Não podem ser desativados.</li>
            <li style={{ marginBottom: '6px' }}><strong>Cookies de análise:</strong> usados para medir o desempenho do site. Você pode recusá-los no banner de cookies.</li>
            <li style={{ marginBottom: '6px' }}><strong>LocalStorage:</strong> usamos o armazenamento local do navegador para preferências (ex: modo escuro, favoritos offline).</li>
          </ul>
          <p style={{ marginTop: '10px' }}>Você pode limpar os cookies e dados de armazenamento a qualquer momento pelas configurações do seu navegador.</p>
        </Section>

        <Section title="4. Compartilhamento com Terceiros">
          <p>O Ofertiz utiliza os seguintes serviços de terceiros que podem processar seus dados:</p>
          <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '8px' }}>
              <strong>Google Firebase (Firebase Auth / Firestore):</strong> Serviço de autenticação e banco de dados. Seus dados são armazenados nos servidores do Google. Consulte a{' '}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary-color)' }}>Política de Privacidade do Google</a>.
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>Google Sign-In:</strong> Ao fazer login com o Google, o serviço compartilha nome, e-mail e foto de perfil com o Ofertiz.
            </li>
            <li style={{ marginBottom: '8px' }}>
              <strong>Lojas parceiras:</strong> Ao clicar em um link de oferta, você será redirecionado ao site da loja. O Ofertiz não tem controle sobre os dados coletados por esses sites.
            </li>
          </ul>
          <p style={{ marginTop: '10px' }}><strong>Não vendemos seus dados</strong> a terceiros para fins de marketing.</p>
        </Section>

        <Section title="5. Retenção de Dados">
          <p>Seus dados são mantidos enquanto sua conta estiver ativa. Nas seguintes situações, podemos manter dados por período superior:</p>
          <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '6px' }}>Dados de comentários: mantidos mesmo após exclusão da conta (anonimizados).</li>
            <li style={{ marginBottom: '6px' }}>Logs de acesso: mantidos por até 6 meses para fins de segurança.</li>
            <li style={{ marginBottom: '6px' }}>Dados de transações de pontos: mantidos por até 1 ano para auditoria.</li>
          </ul>
          <p style={{ marginTop: '10px' }}>Após a exclusão da conta, os dados pessoais identificáveis são removidos em até <strong>30 dias corridos</strong>.</p>
        </Section>

        <Section title="6. Seus Direitos (Art. 18 da LGPD)">
          <p>Como titular dos dados, você tem os seguintes direitos, que podem ser exercidos através do seu perfil ou pelo canal de privacidade:</p>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '12px', marginTop: '12px' }}>
            {[
              { icon: 'fa-eye', title: 'Acesso', desc: 'Consultar quais dados temos sobre você' },
              { icon: 'fa-edit', title: 'Correção', desc: 'Corrigir dados incompletos ou desatualizados' },
              { icon: 'fa-trash-alt', title: 'Eliminação', desc: 'Solicitar a exclusão dos seus dados' },
              { icon: 'fa-download', title: 'Portabilidade', desc: 'Receber seus dados em formato legível' },
              { icon: 'fa-ban', title: 'Oposição', desc: 'Opor-se a determinados tratamentos' },
              { icon: 'fa-undo', title: 'Revogação', desc: 'Revogar o consentimento dado anteriormente' },
            ].map(({ icon, title, desc }) => (
              <div key={title} style={{ padding: '16px', border: '1px solid var(--border-color)', borderRadius: '8px', textAlign: 'center' }}>
                <i className={`fas ${icon}`} style={{ fontSize: '20px', color: 'var(--primary-color)', marginBottom: '8px' }}></i>
                <div style={{ fontWeight: '700', color: 'var(--text-primary)', marginBottom: '4px' }}>{title}</div>
                <div style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>{desc}</div>
              </div>
            ))}
          </div>
          <p style={{ marginTop: '16px' }}>
            Para exercer qualquer um desses direitos, acesse{' '}
            <Link to="/perfil" style={{ color: 'var(--primary-color)' }}>seu perfil</Link>{' '}
            ou envie um e-mail para{' '}
            <a href="mailto:contato@ofertiz.com.br" style={{ color: 'var(--primary-color)' }}>contato@ofertiz.com.br</a>{' '}
            com o assunto <em>"LGPD — Direitos do Titular"</em>. Responderemos em até <strong>15 dias úteis</strong>.
          </p>
        </Section>

        <Section title="7. Segurança dos Dados">
          <p>Adotamos medidas técnicas e organizacionais para proteger seus dados:</p>
          <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
            <li style={{ marginBottom: '6px' }}>Comunicação criptografada via HTTPS/TLS.</li>
            <li style={{ marginBottom: '6px' }}>Senhas armazenadas com hash seguro pelo Firebase.</li>
            <li style={{ marginBottom: '6px' }}>Acesso aos dados de produção restrito à equipe autorizada.</li>
            <li style={{ marginBottom: '6px' }}>Tokens de autenticação com validade e renovação automática.</li>
          </ul>
          <p style={{ marginTop: '10px' }}>Em caso de incidente de segurança envolvendo seus dados, você será notificado conforme exigido pela LGPD.</p>
        </Section>

        <Section title="8. Alterações nesta Política">
          <p>Esta Política pode ser atualizada periodicamente. Quando isso ocorrer, notificaremos você através de aviso no site ou por e-mail, caso a alteração seja relevante. Recomendamos que você a revise periodicamente.</p>
        </Section>

        <Section title="9. Contato e Canal de Privacidade (DPO)">
          <div style={{ padding: '20px', backgroundColor: 'rgba(52, 131, 250, 0.05)', borderRadius: '8px', border: '1px solid rgba(52, 131, 250, 0.15)' }}>
            <p><strong>Encarregado de Proteção de Dados (DPO):</strong></p>
            <p style={{ marginTop: '8px' }}>
              📧 <a href="mailto:contato@ofertiz.com.br" style={{ color: 'var(--primary-color)' }}>contato@ofertiz.com.br</a><br />
              📞 (75) 98146-2701<br />
              <span style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>Use o assunto: <em>"LGPD — Direitos do Titular"</em></span>
            </p>
          </div>
        </Section>

        <div style={{ borderTop: '1px solid var(--border-color)', paddingTop: '24px', display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          <Link to="/termos-de-uso" style={{ color: 'var(--primary-color)', fontSize: '14px', fontWeight: '600', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
            <i className="fas fa-file-alt"></i> Ver Termos de Uso
          </Link>
          <Link to="/" style={{ color: 'var(--text-secondary)', fontSize: '14px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
            <i className="fas fa-home"></i> Voltar para a Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PoliticaPrivacidade;
